import ReportCustomTable from './reportCustomTable'
export default ReportCustomTable
